/**
 * React hooks for permission checks.
 *
 * P1-3 RBAC audit 2026-05-20: thay thế pattern rải rác `user?.role === 'secretary'`
 * khắp pages. Mirror backend permissions ở `utils/permissions.ts`.
 */
import { useAppSelector } from './redux'
import {
  hasPermission,
  hasAnyPermission,
  hasRole,
  type Permission,
  type Role,
} from '../utils/permissions'

export function useRole(): string | undefined {
  return useAppSelector((s) => s.auth.user?.role)
}

export function usePermission(permission: Permission): boolean {
  const role = useRole()
  return hasPermission(role, permission)
}

export function useAnyPermission(permissions: Permission[]): boolean {
  const role = useRole()
  return hasAnyPermission(role, permissions)
}

export function useHasRole(roles: Role[]): boolean {
  const role = useRole()
  return hasRole(role, roles)
}
